import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { useCloseTab } from '../../components/tabs/TabsContext';
import { COLOR_PATH, getColorById, updateColor } from '../../api/colorApi';
import Input from '../../components/Input';
import { onChange } from '../../utils/functions';
import Button from '../../components/Button';
import Textarea from '../../components/Textarea';
import { toast } from 'react-toastify';
import { useApiProgress } from '../../hooks/ApiProgress';
import { VALIDATION_MESSAGE } from '../../utils/constants';
import Spinner from '../../components/Spinner';

const ColorEditPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const { id } = useParams();
    const closeTab = useCloseTab()
    const [color, setColor] = useState({

    })
    const [errors, setErrors] = useState({})
    const pendingApiCall = useApiProgress('put', `${COLOR_PATH}`, false)
    const pendingApiCallLoading = useApiProgress('get', `${COLOR_PATH}`, false)

    useEffect(() => {
        getColorById(id).then(res => setColor(res.data))
    }, [id])

    const onClickSubmit = () => {
        updateColor(id, color).then(res => {
            closeTab()
            toast.success('Renk güncellendi')
        }).catch(err => {
            toast.error(VALIDATION_MESSAGE)
            setErrors(err.response.data.validationErrors)
        })
    }

    if (pendingApiCallLoading) return (
        <div className='flex justify-center'>
            <Spinner />
        </div>
    )

    return (
        <div className='grid grid-cols-1 place-items-center'>
            <div className='col-span-6 w-96'>
                <label className='text-xl mb-5 block dark:text-white'>Renk Düzenle</label>
                <Input
                    label='Renk Kodu'
                    name='code'
                    value={color.code}
                    placeholder='Renk kodu girin'
                    error={errors.code}
                    onChange={e => onChange(e, setColor, setErrors)}
                />
                <Input
                    label='Renk Adı'
                    name='name'
                    value={color.name}
                    placeholder='Renk adı girin'
                    error={errors.name}
                    onChange={e => onChange(e, setColor, setErrors)}
                />
                <Input
                    label='Hex Kodu'
                    name='hexCode'
                    value={color.hexCode}
                    placeholder='Hex kodu girin'
                    error={errors.hexCode}
                    onChange={e => onChange(e, setColor, setErrors)}
                />
                <Textarea
                    label='Açıklama'
                    name='description'
                    value={color.description}
                    placeholder='Açıklama girin'
                    onChange={e => onChange(e, setColor, setErrors)}
                />
                <div className='flex justify-center'>
                    <Button
                        text='Kaydet'
                        variant='green'
                        onClick={onClickSubmit}
                        pending={pendingApiCall}
                    />
                </div>
            </div>
        </div>
    )
}

export default ColorEditPage